import { useRef } from 'react';
import Image from 'next/image';
import Button from '../ui/Button';
import gsap from "gsap";
import { useGSAP } from '@gsap/react';
import useFormStore from "../../stores/FormStore.jsx";
import LinkLikeButton from "../ui/LinkLikeButton";


// interface HomeCTAProps {
//   image: { url: string };
//   title: string;
//   text: string;
// }

const HomeCTA = ({image, text, title, buttonText, lang, menu}) => {

  const sectionRef = useRef(null)
  const infoContainerRef = useRef(null)
  const titleRef = useRef(null)
  const textRef = useRef(null)
  const buttonWrapperRef = useRef(null)
  const imageParallaxWrapper = useRef(null)
  const imageParallax = useRef(null)
    const {
        openPopUp, setOpenPopUp
    } = useFormStore();

  const contacts = menu?.find(
      item => item.text === 'Contacts'
  );

  useGSAP(() => {
  const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
      gsap.fromTo(titleRef.current, { opacity: 0, y: '4rem' }, {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: infoContainerRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0, y: '3rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.2,
        scrollTrigger: {
          trigger: infoContainerRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(buttonWrapperRef.current, { opacity: 0, y: '3rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.5,
        scrollTrigger: {
          trigger: infoContainerRef.current,
          start: "top 70%",
        },
      });



      const q = gsap.utils.selector(imageParallax);


        gsap.fromTo(q("img"), 
          { y: "-20%" }, 
          {
            y: "20%",
            ease: "none",
            scrollTrigger: {
              trigger: imageParallaxWrapper.current,
              start: "top bottom",
              end: "bottom top",
              scrub: 0,
            }
          }
        )

    });

    return () => mm.revert();
  }, {scope: sectionRef});
  
  return (
    <section ref={sectionRef} className="flex container-max flex-col pb-[4rem] md:pb-[5rem] lg:pb-[6rem] xl:pb-[8rem]">
            <div ref={imageParallaxWrapper} className="mb-[2.4rem] flex items-center overflow-hidden justify-center md:mb-[4rem] lg:mb-[8rem] w-full relative h-[32rem] md:h-[40rem] lg:md:h-auto lg:aspect-[1/0.32]">
              <div ref={imageParallax} className='relative h-full lg:h-[150%] w-full'>
                <Image
                  src={image?.url}
                  alt={image?.alt}
                  fill
                  sizes="100vw"
                  quality={80}
                  className="w-auto object-cover"
                />
              </div>
            </div>

            <div ref={infoContainerRef} className='container-padding text-center flex flex-col items-center'>
              <h3 ref={titleRef} className='mb-[1.2rem] md:mb-[2rem] lg:mb-[2.4rem] [&>.selected]:italic [&>.selected]:text-dusty-blue-light' dangerouslySetInnerHTML={{__html: title}}/>
              <p ref={textRef} className='max-w-[50rem] text-1 mb-[3.2rem] md:mb-[4rem]'>{text}</p>
              <div ref={buttonWrapperRef}>
                {lang === 'en' ? (
                    contacts && (
                      <LinkLikeButton trianglesColorClass={'bg-sky-blue'} className="w-fit" isFullSized={true} href={contacts?.link}>
                        {buttonText}
                        <svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                        </svg>
                      </LinkLikeButton>
                    )
                ) : (
                    <Button onClick={() => {
                      setOpenPopUp(true)
                    }} trianglesColorClass={'bg-sky-blue'} className="w-fit" isFullSized={true}>
                      {buttonText}
                      <svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                      </svg>
                    </Button>
                )}
              </div>
            </div>


    </section>
  );
};

export default HomeCTA;